import { FaArrowUpRightFromSquare, FaGithub } from 'react-icons/fa6';
import { Modal } from '../modal/modal';
import { ProjectProps } from './contracts/project-props';
import { isRepoLink } from '../link-utils';

/**
 * Compact, image-less project entry rendered as a terminal-style row.
 * Used for hardware / tooling projects that have no screenshot, so the
 * absence of an image reads as intentional rather than missing content.
 */
export function ProjectRow(props: ProjectProps) {
  const repo = isRepoLink(props.link);

  const openModal = () => {
    const dialog = document.getElementById(props.id) as HTMLDialogElement | null;
    dialog?.showModal();
  };

  return (
    <>
      <button
        type="button"
        onClick={openModal}
        className="group flex w-full items-start gap-3 px-4 py-4 text-left transition-colors hover:bg-elevated"
      >
        <span aria-hidden className="mt-0.5 font-mono text-sm text-accent">
          {'>'}
        </span>

        <span className="min-w-0 flex-1">
          <span className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <span className="font-mono text-sm font-medium text-fg">{props.title}</span>
            {props.tag && (
              <span className="rounded border border-border px-1.5 py-0.5 font-mono text-[11px] uppercase tracking-wide text-muted">
                {props.tag}
              </span>
            )}
            {props.link && (
              <span className="inline-flex items-center gap-1 font-mono text-[11px] text-accent">
                {repo ? (
                  <>
                    <FaGithub aria-hidden /> repo
                  </>
                ) : (
                  <>
                    <span className="h-1.5 w-1.5 rounded-full bg-accent" /> live
                  </>
                )}
              </span>
            )}
          </span>
          <span className="mt-1 block line-clamp-2 text-sm leading-relaxed text-muted">
            {props.excerpt}
          </span>
        </span>

        <FaArrowUpRightFromSquare
          aria-hidden
          className="mt-1 shrink-0 text-xs text-muted opacity-0 transition-opacity group-hover:opacity-100"
        />
      </button>

      <Modal
        id={props.id}
        title={props.title}
        mainInfo={props.description ?? props.excerpt}
        image={props.logo}
        link={props.link}
        blogSlug={props.blogSlug}
      />
    </>
  );
}
